jQuery(document).ready(function() {

    jQuery('.page-template-template-kcma-code-entry form').on('submit', function(e) {
        e.preventDefault();
        console.log(e);

        var field = jQuery(this).find('input[type=text]'),
            code = field.val();

        window.location = code;
    });

    if( jQuery('.page-template-template-kcma-code-entry form').length > 0 ) {
        jQuery('input[type=text]').focus();
    }
    
    if( jQuery('body.error404').length > 0 ) {
        var path = window.location.pathname;
        var path = path.split('/');
        var code = path.pop();

        if( path.includes('kcma') ) {
            window.location = '/kcma?e=1&c=' + code;
        }
    }

});
  